function openInvoicePdf(invoiceId, memberId) {
  window.open(`/members/${memberId}/member_invoices/${invoiceId}/pdf`);
}
export default openInvoicePdf;
